module.exports = "/_next/static/images/lundin-mining-37f88e1e5df5883f75e9693a144e973c.png";